<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.RETURNVARIABLENAME"
        nolabel
        :placeholder="$t('search.returnreason')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        RETURNVARIABLENAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        RETURNVARIABLENAME: null,
      };
    },
  },
};
</script>

<style></style>
